import { useState, useRef, useEffect } from "react";
import { Catalogos } from "../../services/Catalogos";
import { UseFormProps, useForm } from "../../hooks/useForm";
import { IOCServiceDos } from "../../services/IOCServiceDos";
import { Helper } from "../../helper/Helper";
import { Modal } from "../modal/ModalPage";

import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import Footer from "react-multi-date-picker/plugins/range_picker_footer";
import Gregorian_es from "react-date-object/locales/gregorian_es";
import transition from "react-element-popper/animations/transition"
//import '../../css/stylesmsvs.css'

export class TabIOCForm implements UseFormProps {
    R2_01:string = '' ;
    R2_02:string = '' ;
    R2_03:string = '' ;
    R2_04:string = '' ;
    R2_05:string = '' ;

    rutaTematicaMes:string = '' ;

    ID_TIPO_PRDO:string = '' ;
    ID_TIPO_LNEA:string = '' ;
    ID_CLSN_VVNA:string = '' ;
    ID_NVEL_INGO:string = '' ;
    ID_GRPO_EDAD:string = '' ;
    CV_ENTD_FDRA:string = '' ;
    ID_TIPO_CRDO:string = '' ;

    CV_ZONA_CNSN_URBA:string = '' ;
    CV_NVEL_MVLD_ADCA:string = '' ;

    fechaRango:any[]=[null, null]
    fechaInicio:Date = Catalogos.FIRST_DATE;
    fechaFin:Date = Catalogos.FIRST_DATE;

}

export const TabIOC = () => {

    const { elementos, reset, handleClickEvent, updateAttDate } = useForm<TabIOCForm>(new TabIOCForm() ) ;
    
    const ahref = useRef<HTMLAnchorElement>(null);
    const refBtnGenDesc = useRef<HTMLButtonElement>(null);
    const divCollapse = useRef<HTMLDivElement>(null);
    
    const [ descargando, setDescargando ] = useState<boolean>(false) ;
    const [ fileReady, setFileReady ] = useState<boolean>(false) ;
    const [ error, setError ] = useState<string>('');
    const [ toggle, setToggle ] = useState(false);
    const [ datePicker, setDatePicker ] = useState<any>(null);
    
    const [ toggleUseEffect, setToggleUseEffect ] = useState(false); // Forzar lanzar useEffect si es true

    const reset2 = () => {
        reset();
        
        const radiosVars = document.querySelectorAll<HTMLInputElement>( '.queryVars' );
        radiosVars.forEach(value => {
            value.disabled = false ;
        });
        const radiosMet = document.querySelectorAll<HTMLInputElement>( '.queryMetricas' );
        radiosMet.forEach(value => {
            value.disabled = true ;
        });
        if (divCollapse.current && divCollapse.current.className) {
           divCollapse.current.className = 'collapse hide';
        }
        if ( refBtnGenDesc && refBtnGenDesc.current ) {
            refBtnGenDesc.current.disabled = false ;
        }

        setDescargando(false) ;
        setFileReady(false) ;
        setError('')
        
        setToggleUseEffect( true )
    }

    const handleDates = (dP:any) => {
        console.log(dP)
        
        setDatePicker(dP);
        if( dP.length === 1 ) {
            updateAttDate( 'fechaInicio', new Date( dP[0].year, dP[0].month-1, 1 ) )
        } else if( dP.length === 0 ) {
            updateAttDate( 'fechaInicio', Catalogos.FIRST_DATE )
        }
    }

    const updateDates = () => {
        if(datePicker) {
            if( datePicker.length === 1 ) {
                updateAttDate( 'fechaFin', Catalogos.FIRST_DATE )
            } else if( datePicker.length === 2 ) {
                updateAttDate( 'fechaFin', new Date( datePicker[1].year, datePicker[1].month-1, 2 ) )
            } else {
                updateAttDate( 'fechaFin', Catalogos.FIRST_DATE )
            }
        } else {
            updateAttDate( 'fechaFin', Catalogos.FIRST_DATE )
        }
    }
    

    const handleSubmit = async () => {
        console.log( 'handleSubmit()', elementos )
        
        const iocServ = new IOCServiceDos() ;
        setDescargando(true) ;
        setFileReady(false) ;
        setError('')
        setToggle(false)
        if ( refBtnGenDesc && refBtnGenDesc.current ) {
            refBtnGenDesc.current.disabled = true ;
        }
        await iocServ.consultaIOC( elementos )
            .then( data =>{
                if( data ) {
                    setFileReady(true) ;
                    setDescargando(false) ;
                    if( ahref && ahref.current ) {
                        ahref.current.className = '' ;
                        ahref.current.download = Helper.getFileNameExt( 'Masivos_IOC', 'txt') ;
                        ahref.current.target = '_blank' ;
                        ahref.current.href = URL.createObjectURL( new Blob( [ data ], { type: 'text/plain' } ) ) ;
                        ahref.current.click();
                    }
                } else {
                    console.error("No se genero data/blob.")
                    setDescargando(false) ;
                    setError('Ocurrio algún error al generar el archivo.');
                }
            }).catch(e => {
                setDescargando(false) ;
                setError(e.message);
                if ( refBtnGenDesc && refBtnGenDesc.current ) {
                    refBtnGenDesc.current.disabled = false ;
                }
            });
    }

    const updatePage = () => {
        /* Variables */
        let alMenosUnQueryVarsSelected = false ;
        let numMaxQueryVarsSelected = 0 ;
        const radiosV = document.querySelectorAll<HTMLInputElement>( '.queryVars' );
        radiosV.forEach(value => {
            if(value.checked) {
                alMenosUnQueryVarsSelected = true
                numMaxQueryVarsSelected++;
            }
        })
        if(numMaxQueryVarsSelected>3) {
            radiosV.forEach(value => {
                if( !value.checked) value.disabled = true ;
            })
            
        } else {
            radiosV.forEach(value => {
                value.disabled = false;
            })
        }

        /* Metricas */
        let numMaxQueryMetricasSelected = 0 ;
        const radiosM = document.querySelectorAll<HTMLInputElement>( '.queryMetricas' );
        radiosM.forEach(value => {
            if(value.checked) {
                numMaxQueryMetricasSelected++;
            }
        })

        if(numMaxQueryMetricasSelected>1) {
            radiosM.forEach(value => {
                if( !value.checked) value.disabled = true ;
            })
            
        } else {
            radiosM.forEach(value => value.disabled = false )
        }

        if ( divCollapse.current && divCollapse.current.className ) {
            if( alMenosUnQueryVarsSelected ) {
                divCollapse.current.className = ' collapse show';
            } else {
                divCollapse.current.className = ' collapse';
            }
        }

        const CV_ZONA_CNSN_URBA = document.querySelectorAll<HTMLInputElement>( '#CV_ZONA_CNSN_URBA' )[0];
        const CV_NVEL_MVLD_ADCA = document.querySelectorAll<HTMLInputElement>( '#CV_NVEL_MVLD_ADCA' )[0];
    
        const R2_01 = document.querySelectorAll<HTMLInputElement>( '#R2_01' )[0];

        if ( R2_01.checked ) {
            if ( numMaxQueryMetricasSelected === 1 ) {
                if( numMaxQueryVarsSelected > 3 ) {
                    //console.log('1')
                    if( !CV_ZONA_CNSN_URBA.checked) {
                        CV_ZONA_CNSN_URBA.disabled = true ;
                    }

                    if( !CV_NVEL_MVLD_ADCA.checked) {
                        CV_NVEL_MVLD_ADCA.disabled = true ;
                    }

                } else {
                    //console.log('2')
                    /*
                    if ( CV_ZONA_CNSN_URBA.checked || CV_NVEL_MVLD_ADCA.checked ) {
                        if( CV_ZONA_CNSN_URBA.checked ) CV_ZONA_CNSN_URBA.click()
                        else if ( CV_NVEL_MVLD_ADCA.checked ) CV_NVEL_MVLD_ADCA.click()
                    
                    }*/
                }
            } else {
                //console.log('3')
                if ( CV_ZONA_CNSN_URBA.checked || CV_NVEL_MVLD_ADCA.checked ) {
                    if( CV_ZONA_CNSN_URBA.checked )
                        CV_ZONA_CNSN_URBA.click()
                    else if ( CV_NVEL_MVLD_ADCA.checked )
                        CV_NVEL_MVLD_ADCA.click()
                }
                CV_ZONA_CNSN_URBA.disabled = true;
                CV_NVEL_MVLD_ADCA.disabled = true;
            }
        } else {
            //console.log('4')
            if ( CV_ZONA_CNSN_URBA.checked || CV_NVEL_MVLD_ADCA.checked ) {
                if( CV_ZONA_CNSN_URBA.checked )
                    CV_ZONA_CNSN_URBA.click()
                else if ( CV_NVEL_MVLD_ADCA.checked )
                    CV_NVEL_MVLD_ADCA.click()

            }
            CV_ZONA_CNSN_URBA.disabled = true;
            CV_NVEL_MVLD_ADCA.disabled = true;
        }
        //console.log('alMenosUnQueryVarsSelected', alMenosUnQueryVarsSelected, 'numMaxQueryVarsSelected', numMaxQueryVarsSelected, 'alMenosUnQueryMetricasSelected', alMenosUnQueryMetricasSelected, 'numMaxQueryMetricasSelected', numMaxQueryMetricasSelected, 'R2_01.checked', R2_01.checked)
    }

    useEffect(() => {
        console.log('useEffect()')
        
        /* cuerpo cuando se monta o se modifica algún elemento del arreglo*/
        if(error !=='') {
            setToggle(true)
        } else {
            setToggle(false)
        }
        try {
            updatePage()
        } catch (e) {
            console.error(e)
            setError('Por el momento el servicio no se encuentra disponible.')
        }

        if( toggleUseEffect )
            setToggleUseEffect( false )
        
        return () => {
            /* cuerpo cuando se desmonta */
        }
    }, [error, elementos, toggleUseEffect]);
    
    return (
        <div className="row">
            <form className="form-group">
            <div className="row">
                <div className="offset-7 offset-md-8 offset-xl-9 mt-2">
                    <button type="reset" className="btn  btn-rojo button-rojo  mt-3 mt-md-0" onClick={ reset2 }>Limpiar consulta</button>
                </div>
            </div>
            
            <div className="row">
                <div className="col-12 mt-1">
                    <div className="card-body">
                        <div className="card border-0">
                            <div className="card-header fondo-blanco border-0" id="accordion">
                                <div className="row form-group">
                                    <div className="col-12">
                                        <p className="bold negro">Se pueden seleccionar hasta 4 variables y "mes" como opción de visualización adicional</p>
                                        <div className="row">
                                            <div className="col-12 col-md-6">
                                                <div className="row">
                                                    {
                                                        Catalogos.CAT_VARIABLES.json.map( (item, i) =>{ return (
                                                            item.Id !== 'CV_ZONA_CNSN_URBA' && item.Id !== 'CV_NVEL_MVLD_ADCA' ? 
                                                                <div key={ item.Id + i } className= 'custom-control custom-checkbox col-12 col-md-6' >
                                                                    <input type="checkbox" name={ item.Id } id={ item.Id } value={ item.Id } className="custom-control-input queryVars"
                                                                        data-toggle="collapse1"
                                                                        data-target="#collapse-ECUVE"
                                                                        onClick={ handleClickEvent }
                                                                        />
                                                                    <label className="custom-control-label" htmlFor={ item.Id } >{ item.Tx }</label>
                                                                </div>
                                                                :
                                                                <span key={ item.Id + i }></span>
                                                             ) })
                                                            
                                                    }
                                                    <div className="custom-control custom-checkbox col-3">
                                                        <input type="checkbox" name="rutaTematicaMes" value="ID_MES" className="custom-control-input" id='rutaTematicaMes' onClick={ handleClickEvent }/>
                                                        <label className="custom-control-label" htmlFor='rutaTematicaMes' >Mes</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="row">
                                                    <div className='custom-control custom-checkbox col-12'>
                                                        <input type="checkbox" name="CV_ZONA_CNSN_URBA" id="CV_ZONA_CNSN_URBA" value="CV_ZONA_CNSN_URBA" className="custom-control-input queryVars"
                                                            data-toggle="collapse1"
                                                            data-target="#collapse-ECUVE"
                                                            onClick={ handleClickEvent }
                                                            />{/*En el correo viene CV_ZONA_CNSN_URBA Correo: Re: Petición de estructuras de WS para ZCU*/}
                                                        <label className="custom-control-label" htmlFor="CV_ZONA_CNSN_URBA" >Créditos formalizados en ZCU</label>
                                                    </div>
                                                    <div className='custom-control custom-checkbox col-12'>
                                                        <input type="checkbox" name="CV_NVEL_MVLD_ADCA" id="CV_NVEL_MVLD_ADCA" value="CV_NVEL_MVLD_ADCA" className="custom-control-input queryVars"
                                                            data-toggle="collapse1"
                                                            data-target="#collapse-ECUVE"
                                                            onClick={ handleClickEvent }
                                                            />
                                                        <label className="custom-control-label" htmlFor="CV_NVEL_MVLD_ADCA" >Créditos formalizados por nivel de movilidad adecuada ZCU</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row form-group mt-4">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12">
                                                <hr></hr>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="bold negro">Periodo</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            
                                            <div className="col-12 col-md-6">
                                                <div className="row">
                                                    <div className="col-12 mt-1">
                                                        <DatePicker
                                                                onlyMonthPicker
                                                                range
                                                                locale={Gregorian_es}
                                                                plugins={[
                                                                    <DatePanel header="Selección"
                                                                            placeholder="Fechas seleccionadas"
                                                                            className=""
                                                                            
                                                                        />,
                                                                    <Footer position="bottom"
                                                                            format="MMM YYYY"
                                                                            names={{
                                                                                selectedDates: "Rango seleccionado",
                                                                                from: "Ini:",
                                                                                to: "Fin:",
                                                                                selectDate: "-",
                                                                                close: "Aceptar",
                                                                                separator: ",",
                                                                            }}
                                                                        />
                                                                    ]}
                                                                    
                                                                /*animations={[
                                                                    transition({
                                                                        from: 35,
                                                                        transition: "all 800ms cubic-bezier(0.335, 0.010, 0.030, 1.360)",
                                                                }),]}*/
                                                                    
                                                                dateSeparator=" a "
                                                                minDate={ Catalogos.MIN_DATE }
                                                                maxDate={ new Date() }
                                                                
                                                                format="MMMM YYYY"
                                                                //numberOfMonths={2}
                                                                title="Seleccione el periodo"
                                                                required
                                                                //id="calPeriodoId"
                                                                inputClass="form-control select-mx"
                                                                editable={false}
                                                                placeholder="Seleccione un periodo"
                                                                hideOnScroll
                                                                onChange={ handleDates }
                                                                id="fechaRango"
                                                                name="fechaRango"
                                                                value={ elementos.fechaRango }
                                                                style={{'width':300, 'cursor':'pointer'}}
                                                                onClose={ updateDates }
                                                            />                                                      
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row form-group" >
                                    <div className="collapse" id="collapse-ECUVE" aria-labelledby="ecuve" data-parent="#accordion" ref={ divCollapse } >
                                        <hr></hr>
                                        <div className={
                                            elementos.R2_01 !== '' &&
                                            elementos.R2_02 === '' &&
                                            elementos.R2_03 === '' &&
                                            elementos.R2_04 === '' &&
                                            elementos.R2_05 === '' 
                                            ? 'col-12 mt-1' : 'col-12 mt-1 oculta' 
                                            }>
                                            Información disponible a partir del 2022 al seleccionar alguna variante por Zonas de Consolidación Urbana (ZCU)
                                        </div>
                                        <div className="col-12 mt-4">
                                            <p className="bold negro">Selecciona las metricas</p>
                                            <div className="row">
                                                {    
                                                    Catalogos.CAT_CUBO_RAMAS.json.map( (item, i) =>{ return (
                                                        <div key={ item.Id + i } className="custom-control custom-checkbox col-12 col-md-4">
                                                            <input type="checkbox" name={ item.Id } id={ item.Id }
                                                                value={ item.Id }
                                                                className="custom-control-input queryMetricas"
                                                                onClick={ handleClickEvent } />
                                                            <label className="custom-control-label" htmlFor={ item.Id } >{ item.TxRama }</label>
                                                        </div> ) })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="row">
                                    <div className="col-12 mt-4 text-center">
                                        {
                                            descargando &&
                                                <span>
                                                    <img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descargando-animado.gif'} className="imgGif" />
                                                    <br></br>
                                                    <span style={{fontSize:'36px'}} >
                                                        Ejecutando <span className="text-danger">Descarga</span>
                                                    </span>
                                                </span>
                                        }
                                        
                                    </div>
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-12 mt-1">
                                                <div className="row align-items-end">
                                                    <div className="col-12 col-md-4">
                                                        
                                                    </div>
                                                    <div className="col-12 col-md-4 text-center">
                                                        <span>
                                                            <a ref={ ahref } href="#" className={ fileReady ? '' : 'oculta' } >
                                                                <span>
                                                                    <img alt="Descargar" src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgGif" />
                                                                    <br></br>
                                                                    <span style={{fontSize:'36px'}} >
                                                                        Decarga <span className="text-danger">Finalizada</span>
                                                                    </span>
                                                                </span>
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div className="col-12 col-md-4">
                                                        
                                                    </div>
                                                </div>
                                                <div className="row align-items-end mt-4">
                                                    <div className="col-12 col-md-4 text-center">
                                                        <button type="button" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' + ( refBtnGenDesc.current?.disabled ? '' : 'invisible' ) } 
                                                            onClick={ e => { window.location.href = '/wps/portal/infonavitmx/mx2/derechohabientes/el_instituto/sii' } }
                                                            >Regresar</button>
                                                    </div>
                                                    <div className="col-12 col-md-4 text-center">
                                                        <span className={ fileReady ? 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' : 'oculta' } onClick={ e => { e.preventDefault(); ahref.current?.click()} }>Exportar descarga
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                                            <img alt="Generando reporte." src={ process.env.REACT_APP_CONTEXT_PATH + '/images/icono-descarga-finalizada.png'} className="imgBtn" />
                                                        </span>
                                                    </div>
                                                    <div className="col-12 col-md-4 text-center">
                                                        <button type="button" className={ 'btn button-rojo btn-rojo  mt-3 mt-md-0  ' + ( refBtnGenDesc.current?.disabled ? '' : 'invisible' ) } 
                                                            onClick={ () => {
                                                                setDescargando(false);
                                                                setFileReady(false);
                                                                if ( refBtnGenDesc && refBtnGenDesc.current ) refBtnGenDesc.current.disabled = false ;
                                                            }}
                                                            >Nueva consulta</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12 mt-1">
                    <div className="row">
                        <div className="col-4 text-right">
                            
                        </div>
                        <div className="col-4 text-center">
                            <button ref={ refBtnGenDesc } type="button" className={ 'btn  btn-rojo button-rojo mt-3 mt-md-0 ' + ( refBtnGenDesc.current?.disabled ? 'invisible' : '' ) } onClick={ handleSubmit }>Generar descarga</button>
                        </div>
                        <div className="col-4 text-left">
                            
                        </div>
                    </div>
                </div>
            </div>

            
            </form>
            {
                error !== '' && <Modal toggle={toggle} mensaje={ error} />
            }
        </div>
    );
}